<template>
	<div class="logout">
		<div v-if="user">Пока :)</div>
	</div>
</template>

<script>
import Pusher from '@/utils/pusher'

export default {
	name: 'LogoutPage',
	computed: {
		user() {
			return this.$store.getters.user
		},
	},
	mounted() {
		let interval = setTimeout(() => {
			this.logout()
			clearInterval(interval)
		}, 1000)
	},
	methods: {
		logout() {
			this.$http.clearToken()
			this.$store.commit('setUser', {
				id: null,
				roles: [],
				name: null,
				phone: null,
				avatar: null,
				token: null,
			})
			Pusher.disconnect()
			this.$nextTick(() => this.$router.push(`/auth`))
		},
	},
}
</script>

<style lang="less" scoped>
.logout {
	width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
